export default
{
    ABORTED   : -2,
    FAILED    : -1,
    PENDING   :  0,
    RESIZING  :  1,
    READY     :  2,
    UPLOADING :  3,
    UPLOADED  :  4
};